import {Stack} from "@mui/material";
import React from "react";
import {Milestone} from "../../../firebase/index.js";
import MilestoneCard from "./MilestoneCard.jsx";


export default function MilestonesLayout({ms}: { ms: Milestone[] }) {
	  
	  const milestones: Milestone[] = ms;
	  
	  const [length, setLength] = React.useState(ms ? ms.length : 0);
	  React.useEffect(() => {
			 milestones && setLength(milestones.length);
	  }, [milestones]);
	  
	  return (
				 <>
						<Stack spacing={2} p={0} alignItems={"center"} justifyContent={"center"}>
							  <Stack sx={{width: "100%"}} alignItems={"stretch"} justifyContent={"center"}>
									 <MilestoneCard key={"header"} m={null} placeAs={"header"} l={length}/>
									 {milestones &&
												[...milestones]
														  .reverse() /* ALREADY ASC ORDERED BY MILLIS VIA FIREBASE QUERY ITSELF */
														  .map((m, index, array) =>
																	 <React.Fragment key={m.milestoneMillis + "-fragment"}>
																			<MilestoneCard key={m.milestoneMillis + "-holder"} m={m} l={length}/>
																			{index < array.length - 1 &&
																					  <MilestoneCard key={m.milestoneMillis + "-between"} m={null} placeAs={"between"}
																										  escorts={{next: m, prev: array[index + 1]}} /* BECAUSE OF REVERSAL */
																										  l={length}
																					  />
																			}
																	 </React.Fragment>
														  )
									 }
							  </Stack>
						</Stack>
				 </>
	  );
}
